<template>
  <div class="search" ref="search">
    <button class="btn-cloak search__toggle" role="button" @click="isOpen = !isOpen">
      <icon class="search__icon" name="search" width="22" height="22" />
    </button>

    <form class="search__form" @submit.prevent="onSubmit">
      <input class="search__control" id="searchQuery" v-model="searchQuery" type="text" placeholder="Поиск по сайту">
    </form>
  </div>
</template>

<script>
import Icon from '../shared/Icon'

export default {
  components: {
    Icon
  },
  data () {
    return {
      isOpen: false,
      isShowForm: false,
      searchQuery: null
    }
  },
  watch: {
    isOpen (val) {
      this.onChange(val)
    }
  },
  created () {
    const self = this

    window.addEventListener('click', function (e) {
      if (self.isOpen && !self.$el.contains(e.target)) {
        self.isOpen = false
      }
    })
  },
  methods: {
    onSubmit () {
      if (this.searchQuery) {
        window.location.replace(`https://kamgov.ru/search?query=${this.searchQuery}`)
      }
    },
    onChange (visible) {
      const { search } = this.$refs

      if (visible) {
        search.classList.add('search--open')

        setTimeout(() => {
          search.classList.add('search--show')
        }, 200)

        this.$nextTick(() => {
          const control = document.getElementById('searchQuery')
          control.focus()
        })
      } else {
        search.classList.remove('search--show')

        setTimeout(() => {
          search.classList.remove('search--open')
        }, 200)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search {
  height: 26px;
  width: 22px;
  position: relative;

  &__toggle {
    background: transparent;
    border-radius: 50%;
    content: '';
    display: block;
    height: 44px;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: background-color 250ms ease;
    width: 44px;
    z-index: 1;

    .search--open & {
      background-color: $white;
    }
  }

  &__icon {
    fill: $white;
    position: relative;
    transition: fill 250ms ease;
    z-index: 1;

    .search--open & {
      fill: $black;
    }
  }

  &__form {
    left: -11px;
    height: 44px;
    visibility: hidden;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    .search--open & {
      visibility: visible;
    }
  }

  &__control {
    @include font-size(13px);

    background: transparent;
    border-radius: 44px;
    border: none;
    font-family: $font-family-arial;
    height: 44px;
    padding: 0;
    transition: width 250ms ease-in;
    width: 44px;

    .search--show & {
      width: 400px;
    }

    .search--open & {
      background: $white;
      padding: 0 20px 0 50px;
    }

    &:focus {
      outline: 0;
    }
  }
}
</style>
